/** @file subtreeOf: a node and all its descendants, parent-first. */
import type { Puppet } from '@zilo/pose3d-format/types/puppet';

/** `node` then its descendants depth-first, children in key order; `[]` for an unknown node. */
export function subtreeOf(puppet: Pick<Puppet, 'nodes'>, node: string): string[] {
  if (!Object.hasOwn(puppet.nodes, node)) return [];
  const names = Object.keys(puppet.nodes);
  const out: string[] = [];
  const visit = (name: string): void => {
    if (out.includes(name)) return;
    out.push(name);
    for (const child of names) if (puppet.nodes[child]?.parent === name) visit(child);
  };
  visit(node);
  return out;
}
